export type MessageType = "SUCCESS" | "INFO" | "WARN" | "ERROR";

export class Message {
  active = false;
  hide = false;
  message: string;
  type: MessageType;
}
